export default "__VITE_ASSET__nRM36r5v__"